import React, { useState } from "react";
import SizeGuider from "./SizeGuider";
import styles from "./sizeGuiderButton.module.scss";
import { FmButton, FmDrawer as FmUIDrawer } from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";

interface SizeGuiderButtonProps {
    children?: React.ReactNode;
    onPlayStateChange?: (isPlaying: boolean) => void;
}

function SizeGuiderButton({
    children,
    onPlayStateChange
}: React.PropsWithChildren<SizeGuiderButtonProps>) {
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const { t } = useTranslation("specialSub");
    const closeUp = () => {
        setModalVisible(false);
        onPlayStateChange?.(true);
    };

    const openUp = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        e.preventDefault();
        setModalVisible(true);
        onPlayStateChange?.(false);
    };
    const  stopPropagation = (e: React.TouchEvent) => {
        return e.stopPropagation();
    }

    return (
        <div className={styles["size-guide"]} 
            onTouchMove={(e) => {
                stopPropagation(e)
            }}
        >
            <FmButton onClick={openUp} variant="text">
                {children}
            </FmButton>
            <FmUIDrawer
                open={modalVisible}
                onClose={closeUp}
                className={styles["size-guide-modal"]}
                anchor="bottom"
                closeable
                closeablePosition="right"
                headerClassName={styles["position-fixed-icon"]}
                fullHeight
            >
                <div className={styles["size-guide-modal-content"]}>
                    <div className={styles["size-guide-title"]}>
                        {t("specialSub:SizeGuide")}
                    </div>
                    <SizeGuider />
                </div>
            </FmUIDrawer>
        </div>
    );
}

export default SizeGuiderButton;
